import { Link } from "react-router";

import { useAuth } from "@/providers";
import { useAgent } from "@/shared/domain/agents/hooks";
import { Goto } from "@/shared/navigation";

interface AgentLinkProps {
  agentId: string;
  /** Open the agent beside the page naming it rather than in place of it. */
  newTab?: boolean;
}

/**
 * An agent's name, linked to its page. The id is what a trigger target
 * stores, so the name is fetched; until it arrives, or if the agent has been
 * deleted, the id renders in its place rather than nothing, since the target
 * that names it is still real.
 */
export function AgentLink({ agentId, newTab = false }: AgentLinkProps) {
  const { currentOrganization } = useAuth();
  const agentQuery = useAgent(agentId, {
    orgId: currentOrganization?.org_id,
  });
  const name = agentQuery.data?.name;

  return (
    <Link
      to={Goto.createAgentRoute(agentId)}
      title={agentId}
      target={newTab ? "_blank" : undefined}
      rel={newTab ? "noreferrer" : undefined}
    >
      {name ?? agentId}
    </Link>
  );
}
